import { Container, i18n, Table, TableRow, http } from "@common";
import { useRef, useCallback, useState } from 'react';
import { AccountStatuslI18N } from "../constant";
import { routerPaths } from '../tool';
import { adminService } from "@api";

const columns = [
    { header: i18n.get('CIS_Admin_GroupManagement_Details_StudentID_Entry'), sortable: true, valuePath: 'studentID' },
    { header: i18n.get('CIS_Admin_GroupManagement_Details_DisplayName_Entry') },
    { header: i18n.get('CIS_Admin_GroupManagement_Details_Email_Entry') },
    { header: i18n.get('CIS_Admin_GroupManagement_Details_LicenseAssigned_Entry') },
    { header: i18n.get('CIS_Admin_GroupManagement_Details_Status_Entry'), sortable: true, valuePath: 'status' },
];

const GroupDetails = (props) => {
    const { groupName, id } = props.match.params;
    const tableRef = useRef();
    const [items, setItem] = useState([]);

    const filter = {
        search: { id: 'search-group-management-details', placeholder: i18n.get('CIS_Admin_GroupManagement_Details_Search_Entry') },
    };

    const buttons = [
        {
            id: "btn-group-management-details-download",
            text: i18n.get('CIS_Admin_Common_Download_Entry'),
            classify: 'info',
            disabled: items?.length === 0,
            onClick: () => doDownload()
        },
    ];

    const doDownload = () => {
        $$.loading(true);
        const exportInfo = tableRef.current.getExportInfo();
        exportInfo.GroupId = [id];
        exportInfo['timeZone'] = new Date().getTimezoneOffset() / -60;
        adminService.groupManagementDownload(exportInfo).then(() => {
            return true;
        }).catch((e) => {
            if (e?.errorCode === http.ErrorCode.CatchErrorCode) {
                $$.loading(false);
                $$.toast(e?.message, 'warning');
            }
        }).finally(() => {
            $$.loading(false);
        });
    };

    const onLoadData = useCallback(async (info) => {
        info.filters['GroupId'] = id;
        const result = await adminService.groupManagementDetails(info);
        setItem(result.items);
        return new Promise((resolve) => {
            resolve(result);
        });
    }, [id]);

    return (
        <Container>
            <Container.Section back={{ text: decodeURIComponent(atob(groupName)), url: routerPaths.groupManagement }} >
                <Table
                    id="table-student-management-details"
                    ref={tableRef}
                    onLoadData={onLoadData}
                    rowTemplate={TableRowTemp}
                    columns={columns}
                    buttons={buttons}
                    filter={filter}
                />
            </Container.Section>
        </Container>
    );
};

class TableRowTemp extends TableRow {
    render(Row, Cell) {
        const { studentId, displayName, email, licenseAssigned, status } = this.props.rowData;
        return (
            <Row>
                <Cell>{studentId || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{displayName || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{email || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{licenseAssigned || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{AccountStatuslI18N[status] || i18n.get('Common_NA_Entry')}</Cell>
            </ Row>
        );
    }
}

export default GroupDetails;